import React, { useRef, useState } from "react";
import { useForm } from "react-hook-form";
import AuthAPI from '~/api/authApi';

function VerificationCodeInput({ length = 6,
                                   onCompleteChange,
                                   apiUrl,
                                   onCallback,
                                   formId,
                                   onVerifyCode,
                               }) {
    const inputsRef = useRef([]);
    const { register, setValue, getValues, watch, handleSubmit } = useForm({
        defaultValues: Object.fromEntries(Array.from({ length }, (_, i) => [`code${i}`, ""])),
    });

    const [isComplete, setIsComplete] = useState(false);
    const [code, setCode] = useState("");
    const [error, setError] = useState(null);

    const handleInput = (e, index) => {
        const value = e.target.value;
        if (/^\d$/.test(value)) {
            setValue(`code${index}`, value);
            if (index < length - 1) inputsRef.current[index + 1]?.focus();
        } else {
            setValue(`code${index}`, "");
        }
        checkComplete();
    };

    const handleBeforeInput = (e) => {
        if (!/^\d$/.test(e.data)) e.preventDefault();
    };

    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace") {
            const currentValue = getValues(`code${index}`);
            if (!currentValue && index > 0) {
                setValue(`code${index - 1}`, "");
                inputsRef.current[index - 1]?.focus();
            } else {
                setValue(`code${index}`, "");
            }
        }
        checkComplete();
    };

    const checkComplete = () => {
        const allValues = Array.from({ length }, (_, i) => getValues(`code${i}`));
        const isComplete = allValues.every((v) => /^\d$/.test(v));
        if (onCompleteChange) {
            onCompleteChange(isComplete);
        }
    };

    watch(() => checkComplete());

    const onSubmit = (data) => {
        setError("");
        const codeString = Object.keys(data)
            .sort()
            .map((key) => data[key])
            .join("");
        if (!codeString || codeString.length < 6) {
            return;
        }
        onVerifyCode && onVerifyCode(true);
        AuthAPI.verify2FaCode(`${apiUrl}/${codeString}`)
            .then((res) => {
                if(res.data?.Succeeded){

                }
                else{
                    setError(res.data?.Message);
                }
                onCallback && onCallback(res);
            })
            .catch((err) => {
                ;
            })
            .finally(() => {
                onVerifyCode && onVerifyCode(false)
            })
    }

    return (
        <form onSubmit={handleSubmit(onSubmit)} id={formId} className="mt-3">
            {
                error && (
                    <div className="text-center">
                        <span className="text-danger fw-bold fs-9">{error}</span>
                    </div>
                )
            }
            <div className="d-flex align-items-center gap-2 mb-3">
                {Array.from({ length }).map((_, i) => (
                    <input
                        key={i}
                        type="text"
                        maxLength={1}
                        className="px-2 text-center form-control"
                        {...register(`code${i}`)}
                        ref={(el) => (inputsRef.current[i] = el)}
                        onBeforeInput={handleBeforeInput}
                        onChange={(e) => handleInput(e, i)}
                        onKeyDown={(e) => handleKeyDown(e, i)}
                    />
                ))}
            </div>
        </form>
    );
}

export default VerificationCodeInput;
